"use client";
import { jsx } from "react/jsx-runtime";
import { createContext, useContext } from "react";
const ExternalPopupConfigContext = createContext(null);
const ExternalPopupConfigProviderClient = ({ children, internalDomains, externalLinkTranslations }) => {
  return /* @__PURE__ */ jsx(
    ExternalPopupConfigContext.Provider,
    {
      value: {
        internalDomains,
        externalLinkTranslations
      },
      children
    }
  );
};
const useExternalPopupConfig = () => {
  const context = useContext(ExternalPopupConfigContext);
  if (!context) {
    throw new Error(
      "useExternalPopupConfig must be used within a ExternalPopupConfigProvider"
    );
  }
  return context;
};
export {
  ExternalPopupConfigProviderClient,
  useExternalPopupConfig
};
